import { Hero, Products, NewsLetter, Footer } from "../../components";

export default function Home() {
  return (
    <main>
      <Hero />
      <Products />
      <NewsLetter />
      <Footer />
    </main>
  );
}
